import React from 'react';
import SectionHeader from './SectionHeader';
import Field from './Field';
import InputSuffix from './InputSuffix';
import ChipRadio from './ChipRadio';
import styles from '../SaleReportPage.module.scss';
import { DEAL_TYPES } from '../constants';
import {
  buildProfileAddressRows,
  buildProfilePriceRows,
  buildProfileInfoRows,
} from '../fieldBuilders';

/* ── Icons ── */
const MapPinIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s-7-7.5-7-13a7 7 0 1 1 14 0c0 5.5-7 13-7 13z" />
    <circle cx="12" cy="9" r="2.5" />
  </svg>
);

const DollarIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9" />
    <path d="M12 6v12" />
    <path d="M9 9h4.5a2 2 0 0 1 0 4H9" />
    <path d="M9 13h5a2 2 0 0 1 0 4H9" />
  </svg>
);

const FrameIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h6" /><path d="M4 4v6" />
    <path d="M20 4h-6" /><path d="M20 4v6" />
    <path d="M4 20h6" /><path d="M4 20v-6" />
    <path d="M20 20h-6" /><path d="M20 20v-6" />
  </svg>
);

const DEAL_OPTIONS = DEAL_TYPES.map((label, i) => ({ value: i, label }));

function ProfileSection({ config, sale, onChange }) {
  const fields = config.fields || {};

  const setField = (key, val) => {
    onChange({ ...config, fields: { ...fields, [key]: val } });
  };

  const setVal = (key, val) => {
    onChange({ ...config, fields: { ...fields, [key + '_edit']: val } });
  };

  const toggleSection = (key, val) => {
    onChange({ ...config, [key]: val });
  };

  if (!sale) return null;

  const dealTypeNum = Number(sale.deal_type);
  const addressRows = buildProfileAddressRows(sale, config);
  const priceRows = buildProfilePriceRows(sale, config);
  const infoRows = buildProfileInfoRows(sale, config);
  const sectionInfoEnabled = config.sectionInfo !== false;

  return (
    <>
      {/* Sub-section A: 매물 주소 */}
      <div className={styles.section}>
        <SectionHeader
          icon={<MapPinIcon />}
          title="매물 주소"
          locked="필수 영역"
        />
        <div className={styles.grid}>
          {addressRows.map(({ key, label, value, span }) => (
            <Field
              key={key}
              label={label}
              span={span}
              toggle
              toggleEnabled={fields[key] !== false}
              onToggle={(v) => setField(key, v)}
            >
              <input
                type="text"
                value={value}
                readOnly
              />
            </Field>
          ))}
        </div>
      </div>

      {/* Sub-section B: 가격 정보 */}
      <div className={styles.section}>
        <SectionHeader
          icon={<DollarIcon />}
          title="가격 정보"
          locked="필수 영역"
        />
        <div className={styles.grid}>
          <Field label="거래 유형" span={12} required>
            <ChipRadio
              options={DEAL_OPTIONS}
              value={dealTypeNum}
              onChange={() => {}}
            />
          </Field>

          {priceRows.map(({ key, label, value, unit, hint, span }) => (
            <Field
              key={key}
              label={label}
              span={span}
              toggle
              toggleEnabled={fields[key] !== false}
              onToggle={(v) => setField(key, v)}
              hint={hint}
            >
              <InputSuffix
                value={value === '-' ? '' : value}
                unit={unit}
                onChange={(v) => setVal(key, v)}
              />
            </Field>
          ))}
        </div>
      </div>

      {/* Sub-section C: 매물 정보 */}
      <div className={`${styles.section} ${!sectionInfoEnabled ? styles.sectionOff : ''}`}>
        <SectionHeader
          icon={<FrameIcon />}
          title="매물 정보"
          toggleEnabled={sectionInfoEnabled}
          onToggle={(v) => toggleSection('sectionInfo', v)}
        />
        <div className={styles.grid}>
          {infoRows.map(({ key, label, value, unit, readOnly }) => (
            <Field
              key={key}
              label={label}
              span={3}
              toggle
              toggleEnabled={fields[key]}
              onToggle={(v) => setField(key, v)}
            >
              {unit ? (
                <InputSuffix
                  value={value === '-' ? '' : value}
                  unit={unit}
                  onChange={(v) => setVal(key, v)}
                />
              ) : readOnly ? (
                <input
                  type="text"
                  value={value}
                  readOnly
                />
              ) : (
                <input
                  type="text"
                  value={value === '-' ? '' : value}
                  onChange={(e) => setVal(key, e.target.value)}
                />
              )}
            </Field>
          ))}
        </div>
      </div>
    </>
  );
}

export default ProfileSection;
